enum SectorFieldNames {
  AssignationsTitle = 'assignationsTitle',
  Code = 'code',
  Color = 'color',
  Description = 'description',
  DetailsTitle = 'detailsTitle',
  Id = 'id',
  LocationGeojson = 'locationGeojson',
  LocationTitle = 'locationTitle',
  Name = 'name',
  Sites = 'sites',
  UserId = 'userId',
  UserMemberships = 'userMemberships',
  UserMembershipList = 'userMembershipList',
  LocationMessage = 'locationMessage',
  SiteList = 'SiteList',
}

export default SectorFieldNames;
